<template>
  <div class="bg-white min-h-screen">
    <TransitionRoot appear :show="isOpen" as="template">
      <Dialog as="div">
        <div class="fixed inset-0 z-10 overflow-y-auto">
          <div class="min-h-screen px-4 text-center bg-black bg-opacity-40">
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <DialogOverlay class="fixed inset-0" />
            </TransitionChild>

            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
            >
              <div
                class="inline-block w-full max-w-md p-6 my-48 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-xl"
              >
                <DialogTitle
                  as="h3"
                  class="text-lg font-medium leading-6 text-black text-center"
                >
                  Instalar
                </DialogTitle>
                <div class="mt-2">
                  <p class="text-sm text-dark-gray">
                    Esta app es instalable, si asi lo desea puede hacerlo para
                    una mejor experiencia de usuario.
                  </p>
                </div>

                <div
                  class="mt-6 flex flex-col gap-3 sm:flex-row sm:items-stretch sm:gap-4"
                >
                  <button
                    type="button"
                    class="btn-primary-inline"
                    @click="instalar(true)"
                  >
                    Instalar
                  </button>
                  <button
                    type="button"
                    class="btn-secondary-inline"
                    @click="instalar(false)"
                  >
                    No ahora mismo
                  </button>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>

    <TransitionRoot appear :show="logoutConfirmOpen" as="template">
      <Dialog as="div" class="relative z-50" @close="logoutConfirmOpen = false">
        <div class="fixed inset-0 overflow-y-auto">
          <div
            class="flex min-h-screen items-center justify-center px-4 text-center"
          >
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <DialogOverlay class="fixed inset-0 bg-black bg-opacity-40" />
            </TransitionChild>

            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
            >
              <div
                class="relative inline-block w-full max-w-sm transform overflow-hidden rounded-xl bg-white p-6 text-left align-middle shadow-xl transition-all"
              >
                <DialogTitle
                  as="h3"
                  class="text-center text-lg font-medium leading-6 text-black"
                >
                  Cerrar sesión
                </DialogTitle>
                <p class="mt-3 text-center text-sm text-dark-gray">
                  ¿Querés salir de tu cuenta? Vas a tener que volver a ingresar
                  con tu documento y el código.
                </p>

                <div
                  class="mt-6 flex flex-col gap-3 sm:flex-row sm:items-stretch sm:gap-4"
                >
                  <button
                    type="button"
                    class="btn-primary-inline"
                    @click="confirmLogout"
                  >
                    Cerrar sesión
                  </button>
                  <button
                    type="button"
                    class="btn-secondary-inline"
                    @click="logoutConfirmOpen = false"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>

    <Stepper
      :currentStep="currentStep"
      :authenticatedUser="authenticatedUser"
      :stepsLocked="!isUserFullyVerified"
      :paymentDone="paymentDone"
      @changeStep="changeStep"
      @logout="logout"
    />
    <div class="max-w-3xl mx-auto">
      <CheckUser
        v-if="currentStep <= 1"
        :currentStep="currentStep"
        :authenticatedUser="authenticatedUser"
        :profile-return-step="profileReturnStep"
        @update="saveAuthenticatedUser"
        @changeStep="changeStep"
      />
      <MiSuscripcion
        v-if="currentStep == 2"
        :authenticatedUser="authenticatedUser"
        @selectOrder="onSelectOrder"
      />
      <ListaSubscripciones
        v-if="currentStep == 3"
        :authenticatedUser="authenticatedUser"
        :orderId="selectedOrder.orderId"
        :isEditable="selectedOrder.isEditable"
        :lockReason="selectedOrder.lockReason"
        @changeStep="changeStep"
        @orderCreated="onOrderCreated"
        @orderResolved="onOrderResolved"
      />
      <CartView
        v-if="currentStep == 4"
        :authenticatedUser="authenticatedUser"
        :orderId="selectedOrder.orderId"
        :isEditable="selectedOrder.isEditable"
        :lockReason="selectedOrder.lockReason"
        @changeStep="changeStep"
      />
      <PaymentSection
        v-if="currentStep == 5"
        :authenticatedUser="authenticatedUser"
        :orderId="selectedOrder.orderId"
        :isEditable="selectedOrder.isEditable"
        :lockReason="selectedOrder.lockReason"
        :total="selectedOrder.total"
        @changeStep="changeStep"
        @paymentCompleted="paymentDone = true"
      />
    </div>
    <!-- <OrderBlocked></OrderBlocked> -->
  </div>
</template>

<script>
  import ListaSubscripciones from "./components/ListaSubscripciones.vue";
  import CartView from "./components/CartView.vue";
  import CheckUser from "./components/CheckUser.vue";
  import Stepper from "./components/Stepper.vue";
  import MiSuscripcion from "./components/MiSuscripcion.vue";
  // import OrderBlocked from "./components/OrderBlocked.vue";
  import { ref, watch } from "vue";
  import { globalState } from "./globalState";
  import { clearSubscriberToken, logoutSubscriptionUser } from "./auth";
  import { createToast } from "mosha-vue-toastify";
  import {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    DialogTitle,
  } from "@headlessui/vue";
  // import the styling for the toast
  import "mosha-vue-toastify/dist/style.css";
  import PaymentSection from "./components/PaymentSection.vue";
  export default {
    name: "App",
    components: {
      // OrderBlocked,
      ListaSubscripciones,
      CheckUser,
      Stepper,
      CartView,
      MiSuscripcion,
      TransitionRoot,
      TransitionChild,
      Dialog,
      DialogOverlay,
      DialogTitle,
      PaymentSection,
    },
    setup() {
      const isOpen = ref(false);
      const logoutConfirmOpen = ref(false);
      const deferredPrompt = ref(null);
      const pwaConfig = () => {
        if ("serviceWorker" in navigator) {
          // Use the window load event to keep the page load performant
          navigator.serviceWorker.register("service-worker.js");

          if (!JSON.parse(localStorage.getItem("alreadyAskedInstallation"))) {
            window.addEventListener("beforeinstallprompt", (e) => {
              // Prevent the mini-infobar from appearing on mobile
              e.preventDefault();
              deferredPrompt.value = e;
              isOpen.value = true;
            });
          }
        }
      };
      pwaConfig();

      return {
        isOpen,
        logoutConfirmOpen,
        deferredPrompt,
      };
    },
    data() {
      return {
        authenticatedUser: {},
        currentStep: 0,
        paymentDone: false,
        selectedOrder: {
          orderId: null,
          isEditable: false,
          lockReason: null,
          total: null,
        },
        profileReturnStep: Number(localStorage.getItem("profileReturnStep")) || null,
      };
    },
    computed: {
      isUserFullyVerified() {
        const u = this.authenticatedUser;
        if (!u?.documentNumber) return false;
        const phoneVerified = !!(u.phoneVerified ?? u.PhoneVerified);
        const emailVerified = !!(u.emailVerified ?? u.EmailVerified);
        return phoneVerified && emailVerified;
      },
    },
    created() {
      watch(
        () => globalState.sessionInvalidated,
        (invalidated) => {
          if (!invalidated) return;
          this.authenticatedUser = {};
          this.currentStep = 0;
          this.profileReturnStep = null;
          globalState.sessionInvalidated = false;
          createToast(
            "Tu sesión venció o ya no es válida. Iniciá sesión de nuevo.",
            {
              position: "top-center",
              type: "danger",
              transition: "zoom",
            },
          );
        },
      );
    },
    mounted() {
      localStorage.removeItem("cartProducts");
      this.authenticatedUser =
        JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};

      const hasProfile = !!this.authenticatedUser?.documentNumber;
      const hasSubscriberToken = !!localStorage.getItem("subscriberToken");

      if (hasProfile && !hasSubscriberToken) {
        localStorage.removeItem("authenticatedUser");
        localStorage.removeItem("currentStep");
        localStorage.removeItem("profileReturnStep");
        this.authenticatedUser = {};
        this.currentStep = 0;
        this.profileReturnStep = null;
        createToast(
          "Tu sesión expiró. Volvé a ingresar con tu documento y el código.",
          {
            position: "top-center",
            type: "warning",
            transition: "zoom",
          },
        );
        return;
      }

      if (!hasProfile && hasSubscriberToken) {
        clearSubscriberToken();
      }

      if (!hasProfile) {
        this.currentStep = 0;
        return;
      }

      const savedStep = Number(localStorage.getItem("currentStep")) || 1;
      if (savedStep >= 2 && !this.isUserFullyVerified) {
        this.currentStep = 1;
        localStorage.setItem("currentStep", 1);
      } else if (savedStep >= 3) {
        // selectedOrder can't be restored from localStorage, so go back to step 2
        this.currentStep = 2;
        localStorage.setItem("currentStep", 2);
      } else {
        this.currentStep = savedStep;
      }
    },
    unmounted() {
      localStorage.removeItem("currentStep");
    },
    methods: {
      changeStep(step) {
        if (!Number.isInteger(step)) {
          step = this.isUserFullyVerified ? this.profileReturnStep || 2 : 0;
        }
        if (!this.authenticatedUser?.documentNumber && step > 1) return;
        if (step >= 2 && !this.isUserFullyVerified) {
          createToast("Verificá tu teléfono y tu email antes de continuar.", {
            position: "top-center",
            type: "warning",
            transition: "zoom",
          });
          this.currentStep = 1;
          localStorage.setItem("currentStep", 1);
          return;
        }
        if (step === 1 && this.currentStep > 1) {
          this.profileReturnStep = this.currentStep;
          localStorage.setItem("profileReturnStep", this.currentStep);
        }
        this.currentStep = step;
        localStorage.setItem("currentStep", step);
      },
      async saveAuthenticatedUser(user) {
        this.authenticatedUser = user;
        if (user?.documentNumber) {
          localStorage.setItem("authenticatedUser", JSON.stringify(user));
        } else {
          localStorage.removeItem("authenticatedUser");
        }
        if (this.isUserFullyVerified) {
          this.changeStep(2);
        } else if (user?.documentNumber) {
          this.profileReturnStep = 2;
          localStorage.setItem("profileReturnStep", 2);
          this.changeStep(1);
        } else {
          this.changeStep(0);
        }
      },
      onSelectOrder({ orderId, isEditable, lockReason, total, goToStep }) {
        this.selectedOrder = { orderId, isEditable, lockReason, total };
        this.paymentDone = false;
        this.changeStep(goToStep);
      },
      onOrderCreated(newOrderId) {
        this.selectedOrder = { ...this.selectedOrder, orderId: newOrderId };
      },
      onOrderResolved({ orderId, isEditable, lockReason }) {
        this.selectedOrder = {
          ...this.selectedOrder,
          orderId,
          isEditable,
          lockReason: lockReason || null,
        };
      },
      async instalar(choice) {
        this.isOpen = false;
        localStorage.setItem("alreadyAskedInstallation", true);
        if (choice) this.deferredPrompt.prompt();
        this.deferredPrompt = null;
      },
      logout() {
        this.logoutConfirmOpen = true;
      },
      async confirmLogout() {
        this.logoutConfirmOpen = false;
        await logoutSubscriptionUser();
        this.authenticatedUser = {};
        this.currentStep = 0;
        this.profileReturnStep = null;
      },
    },
  };
</script>

<style>
  #app {
    font-family: Lato;
  }
  .top-50 {
    top: 50%;
  }
  .button {
    -webkit-appearance: none;
  }
</style>
